/**
 * MovementIllustration/index.js
 * desc: airplane movement
 * note: stateless presentational component
 */
'use strict';

import { classNames } from '../../../utilities';
import './styles.css';


const MovementIllustration = ({ className }) => {
    const classList = classNames('movement illustration', className);

    return (
        <figure className={ classList } >
            <svg viewBox="0 0 303 93" xmlns="http://www.w3.org/2000/svg"><path d="M1 92.001c39.87-71.755 213-97.428 301.5-89" /></svg>
        </figure>
    );
};


export default MovementIllustration;
